export const USER_ATTRIBUTE_KEYS = {
  CAMPAIGN_TO_AUTO_SELECT: 'CAMPAIGN_TO_AUTO_SELECT'
};
export const EMPTY_CAMPAIGN_TO_AUTO_SELECT_VALUE = '0';
export const ONE_DAY_IN_MILLISECONDS = 86400000;